import { apiClient } from './api';

export interface CurrencySettings {
  currency_code: string;
  currency_symbol: string;
  currency_name: string;
}

export interface PublicSettings {
  currency_code: string;
  currency_symbol: string;
  currency_name: string;
  platform_name?: string;
}

/**
 * Platform Settings API Service
 */
export const platformSettingsApi = {
  /**
   * Get public platform settings (accessible to all users)
   */
  getPublicSettings: () =>
    apiClient.get<PublicSettings>('/platform-settings/public'),

  /**
   * Update currency settings (super admin only)
   */
  updateCurrencySettings: (data: CurrencySettings) =>
    apiClient.put<{ message: string } & CurrencySettings>('/platform-settings/currency/update', data),
};
